import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "services/axios";

  /* -------------------------------------- Shifts  Cards  Report List ------------------------------- */
  export const getShiftsReportReportList = createAsyncThunk("shiftsReport/getShiftsReportReportList",  
    async (args, thunkApi) => {
    try {
      const { data } = await axios.get(`https://rostoapi.smartgate-egypt.com/Reports/GetShiftsReport`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response.data);
    }
  }
);

 /* --------------------------------------- Shifts Filter Data ------------------------------*/
 export const getShiftsReportReportFilteredData = createAsyncThunk("shiftsReport/getShiftsReportReportFilteredData ", 
  async (args, thunkApi) => {
  try {
    return (args);
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);
export const resetShiftsReportReportFilteredData = createAsyncThunk( "shiftsReport/resetShiftsReportReportFilteredData ", 
  async (args, thunkApi) => { 
  try {
    return args;
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);